import type { PdfCompressRequest } from "@risalabs_frontend_org/oasis-ui-kit";
import type { PdfCompressionRequest } from "../../../api/services/pdfCompressionTypes";

/** Map the merge panel's compression controls onto backend compression settings. */
export const toPdfCompressionRequest = (
  request: PdfCompressRequest,
): PdfCompressionRequest => {
  const file = new File([request.file], request.fileName, {
    type: "application/pdf",
  });
  const payload: PdfCompressionRequest = { file };

  switch (request.compressionType) {
    case "original":
      payload.preset = "original";
      break;
    case "standard":
      payload.preset = "standard";
      break;
    case "medium":
      payload.preset = "high";
      break;
    case "high":
      payload.preset = "maximum";
      break;
    case "custom":
      if (request.customCompressValue === null) {
        throw new Error("Enter a custom PDF compression target.");
      }
      if (request.customCompressMode === "to_size") {
        payload.target_bytes = Math.round(
          request.customCompressValue * 1024 * 1024,
        );
      } else {
        throw new Error("Choose a custom PDF compression target type.");
      }
      break;
  }

  return payload;
};
